// SOSTONERS Logo — clean wordmark: "SOS" magenta + "TONERS" preto, com subtítulo.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const SosLogo = ({ size = 48, showSubtitle = true, dark = false, customLogoUrl = null }) => {
    if (customLogoUrl) {
        return (
            <img
                src={customLogoUrl}
                alt="SOSTONERS"
                style={{ height: size, width: "auto", maxWidth: size * 4, objectFit: "contain" }}
            />
        );
    }
    const fg = dark ? "#FAFAFA" : "#0A0A0A";
    const sub = dark ? "rgba(250,250,250,0.65)" : "rgba(10,10,10,0.65)";
    return (
        <svg
            id="sos-logo-download"
            viewBox="0 0 380 120"
            height={size}
            width={(size * 380) / 120}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="SOSTONERS — Toners e Informática"
        >
            {/* SOS — magenta */}
            <text
                x="0"
                y="68"
                fontFamily="'Cabinet Grotesk', 'Bricolage Grotesque', 'Arial Black', sans-serif"
                fontWeight="900"
                fontSize="64"
                fill="#E6007E"
                letterSpacing="-3"
            >
                SOS
            </text>
            {/* TONERS — preto (ou branco em tema escuro) */}
            <text
                x="125"
                y="68"
                fontFamily="'Cabinet Grotesk', 'Bricolage Grotesque', 'Arial Black', sans-serif"
                fontWeight="900"
                fontSize="64"
                fill={fg}
                letterSpacing="-3"
            >
                TONERS
            </text>
            {showSubtitle && (
                <text
                    x="2"
                    y="98"
                    fontFamily="'JetBrains Mono', 'IBM Plex Mono', monospace"
                    fontWeight="600"
                    fontSize="11"
                    letterSpacing="6"
                    fill={sub}
                >
                    TONERS · INFORMÁTICA
                </text>
            )}
        </svg>
    );
};

export const useLogoUrl = () => {
    const [url, setUrl] = useState(null);
    useEffect(() => {
        api.get("/settings").then((r) => {
            if (r.data?.logo_url) setUrl(r.data.logo_url);
        }).catch(() => {});
    }, []);
    return url;
};

export const downloadSvg = () => {
    const svg = document.querySelector("#sos-logo-download")?.outerHTML;
    if (!svg) return;
    const blob = new Blob([svg], { type: "image/svg+xml" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "sostoners-logo.svg";
    a.click();
};

export default SosLogo;
